import { useMutation, useQuery } from "@tanstack/react-query";
import { client } from "../clients";

const fetchFolderDropdown = async ({ query = {} }) => {
    return client("/fetch_secrets", {
        method: "POST",
        data: query,
    }).then((data: any) => data);
};

const useFolderDropdown = ({ query = {}, options }: any = {}) => {
    return useQuery({
        queryKey: ["destination-dropdown", query],
        queryFn: () => fetchFolderDropdown({ query }),
        ...options,
    }) as any;
};

function useCreateDestination({ options }: any) {
    return useMutation({
        mutationFn: (reqBody: any) =>
            client("/create_destination", {
                method: "POST",
                data: reqBody,
            }),
        ...options,
    }) as any;
}


const fetchCountrySecrets = async ({ headers = {} }) => {
    return client("/fetch_secrets_by_country", {
        method: "POST",
        headers: headers,
    }).then((res: any) => res.data);
};

const useCountrySecrets = ({ headers = {}, options }: any = {}) => {
    return useQuery({
        queryKey: ["country-secrets", headers],
        queryFn: () => fetchCountrySecrets({ headers }),
        ...options,
    }) as any;
};

export {
    useCreateDestination,
    useFolderDropdown,
    useCountrySecrets
};